import enMessages from '../locales/th_TH.json';

const EnLang = {
    messages: {
        ...enMessages
    },
    locale: 'en-TH',
};
export default EnLang;
